import { render, staticRenderFns } from "./MetricsDashboard.vue?vue&type=template&id=70bd509c"
import script from "./MetricsDashboard.vue?vue&type=script&lang=js"
export * from "./MetricsDashboard.vue?vue&type=script&lang=js"
import style0 from "./MetricsDashboard.vue?vue&type=style&index=0&id=70bd509c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports